import { IRevenueScheduleSummary } from '@monetize/types/app';
import { useAccordionItemContext } from '@chakra-ui/react';
import { FC } from 'react';
import {
  MAccordionCustomButton,
  MAccordionItem,
  MAccordionPanel,
} from '../Monetize';
import { ScheduleVersionPeriodsTable } from './ScheduleVersionPeriodsTable';

interface PreviousScheduleAccordionItemProps {
  value: string;
  schedule: IRevenueScheduleSummary;
}

interface PreviousScheduleAccordionItemBodyProps {
  schedule: IRevenueScheduleSummary;
}

// v3 dropped v2's render-prop children (`{({isExpanded}) => ...}`) on
// AccordionItem - the isExpanded-dependent content moves into its own child
// component reading `useAccordionItemContext()`, same pattern as Track H's
// other shared wrappers.
const PreviousScheduleAccordionItemBody = ({
  schedule,
}: PreviousScheduleAccordionItemBodyProps) => {
  const { expanded: isExpanded } = useAccordionItemContext();
  const versionLabel =
    schedule.version != null
      ? `Version ${schedule.version}`
      : (schedule.references?.revenueContractId ?? schedule.id);

  return (
    <>
      <MAccordionCustomButton isExpanded={isExpanded} label={versionLabel} />
      <MAccordionPanel m="0">
        {isExpanded && <ScheduleVersionPeriodsTable schedule={schedule} />}
      </MAccordionPanel>
    </>
  );
};

/**
 * A single inactive-version row. Rendered inside the shared controlled
 * MAccordion in RevenueContractScheduleTab so expand-all / collapse-all can
 * drive every version's expanded state together.
 */
export const PreviousScheduleAccordionItem: FC<
  PreviousScheduleAccordionItemProps
> = ({ value, schedule }) => {
  return (
    <MAccordionItem value={value} borderColor="tGray.lightGray" mb={4}>
      <PreviousScheduleAccordionItemBody schedule={schedule} />
    </MAccordionItem>
  );
};
